import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    width: '100%',
    maxHeight: '85vh'
  },
  table: {
    minWidth: '100%'
  },
  tableHead: {
    '& > *': {
      fontWeight: 'bold'
    }
  },
  noResultsRow: {
    textAlign: 'center'
  }
}));
